import { Col, List, Typography } from 'antd';

import { Marketplace, Paginator } from 'interfaces/marketplace';

import ItemCard from '../ItemCard';
import NoResults from '../NoResults';

type Props = {
  items?: Marketplace[];
  loading: boolean;
  pagination: Paginator;
  onPageChange: (page: number, pageSize: number) => void;
  cleanAllFilters: () => void;
  isFallback?: boolean;
  changeFallbackPage?: (page: number) => void;
};

const { Title } = Typography;

const MobileItemList = ({
  items,
  loading,
  pagination,
  onPageChange,
  cleanAllFilters,
  isFallback,
  changeFallbackPage
}: Props) => {
  if (!items?.length && !loading) {
    return (
      <Col xs={24} md={0}>
        <NoResults cleanFilters={cleanAllFilters} />
      </Col>
    );
  }

  return (
    <Col xs={24} md={0}>
      {isFallback && (
        <Title level={5} style={{ fontSize: '20px' }}>
          Veja todos os eventos disponíveis
        </Title>
      )}
      <List
        loading={loading}
        dataSource={items}
        renderItem={item => <ItemCard key={item.id} item={item} showTooltip />}
        pagination={{
          pageSize: pagination.itemsPerPage,
          align: 'center',
          defaultPageSize: 8,
          current: pagination.page,
          onChange: !isFallback ? onPageChange : changeFallbackPage,
          total: pagination.totalItems,
          showTotal: total => `Total ${total} itens`
        }}
        grid={{ gutter: 5, column: 2 }}
      />
    </Col>
  );
};

export default MobileItemList;
